<template>
    <div ref="searchableInput" class="searchable-dropdown" v-click-outside="handleClickOutside">
        <input ref="inputField" @focus="$emit('inputFocus')" @input="triggerSearch" :class="['form-control', inputClass]" :placeholder="placeholder" @click="inputClicked" v-model="inputText" />
        <div ref="dropdownValues" v-show="isDropdownShown" class="searchable-dropdown-overlay" :style="{
            maxHeight: `${maxHeight}px`,
            width: `${inputWidth}px`
        }">
            <div v-if="inputText.length === 0 && options.length === 0" class="searchable-dropdown-item"><span class="font-italic indicator-text">Type something to search...</span></div>
            <div v-else-if="options.length === 0 && !isLoading" class="searchable-dropdown-item"><span class="font-italic indicator-text">No result</span></div>
            <div v-else-if="isLoading" class="searchable-dropdown-item"><span class="font-italic indicator-text">Loading results...</span></div>
            <template v-else-if="options.length > 0">
                <a href="javascript: void(0);" class="searchable-dropdown-item" v-for="(option, index) in options" :key="index" @click="selectOption(option.value)">
                    {{option.text}}
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
export default {
    'name': 'SearchableDropdown',
    'directives': {
        ClickOutside
    },
    'props': {
        'options': {
            'type': Array,
            default () {
                return [];
            }
        },
        'placeholder': {
            'type': String,
            'default': 'Type to search'
        },
        'isLoading': {
            'type': Boolean,
            'default': false
        },
        'maxHeight': {
            'type': Number,
            'default': 400
        },
        'inputClass': {
            'type': String | Object,
            'default': ''
        }
    },
    'watch': {
        isDropdownShown (isShown) {
            this.$nextTick(() => {
                this.$refs.dropdownValues.scrollTop = 0;
            });
        }
    },
    data () {
        return {
            'inputWidth': 0,
            'isDropdownShown': false,
            'inputText': ''
        };
    },
    mounted () {
        this.inputWidth = this.$refs.inputField.clientWidth;
    },
    'methods': {
        handleClickOutside () {
            let searchableInput = this.$refs.searchableInput;
            let searchableInputNodes = [];
            searchableInputNodes.push(searchableInput);

            searchableInput.childNodes.forEach((node) => {
                searchableInputNodes.push(node);
            });

            if (!(searchableInputNodes.some((dom) => dom === event.target)) && this.isDropdownShown) {
                this.dismissDropdown();
            }
        },
        dismissDropdown () {
            this.isDropdownShown = false;
        },
        inputClicked () {
            this.$refs.inputField.select();
            this.isDropdownShown = !this.isDropdownShown;
        },
        selectOption (selectedValue) {
            this.$emit('selected', selectedValue);
            this.isDropdownShown = false;
        },
        triggerSearch () {
            this.isDropdownShown = true;
            this.$emit('search', this.inputText);
        }

    }
};
</script>

<style>
.searchable-dropdown .searchable-dropdown-overlay{
    margin-top: 3px;
    z-index: 1;
    position: absolute;
    background-color: #fff;
    overflow-y: auto;
    padding: 5px 0;
    border: solid #ccc 1px;
    border-radius: 5px;
}

.searchable-dropdown .searchable-dropdown-overlay .searchable-dropdown-item{
    padding: 5px 10px;
    display: block;
    text-decoration: none;
    color: initial;
}

.searchable-dropdown .searchable-dropdown-overlay a.searchable-dropdown-item:hover{
    color: #fff;
    background-color: #009344;
}

.searchable-dropdown .searchable-dropdown-overlay a.searchable-dropdown-item:active{
    background-color: #017b3a;
}

.indicator-text {
    color: #9499a8;
}
</style>
